import { determineDataSource } from "../../Data/DataStores/DataSource";
import { type ShopfrontThunk } from "../../Utilities/Generic/ActionsHelper";
import { getOption } from "../../Utilities/Platform/Options/Options";

export const SALE_KEYS_SET = "SALE_KEYS_SET";
export const SALE_KEYS_CHANGE = "SALE_KEYS_CHANGE";
export const SALE_KEYS_BACK = "SALE_KEYS_BACK";

export interface SetSaleKeysAction {
    type: typeof SALE_KEYS_SET;
    uuid: string;
}

export interface ChangeSaleKeysAction {
    type: typeof SALE_KEYS_CHANGE;
    uuid: string;
}

export interface BackSaleKeysAction {
    type: typeof SALE_KEYS_BACK;
}

export type SaleKeysActionTypes = SetSaleKeysAction | ChangeSaleKeysAction | BackSaleKeysAction;

export function setSaleKeys(uuid: string): SaleKeysActionTypes {
    return {
        type: SALE_KEYS_SET,
        uuid,
    };
}

export function changeSaleKeys(uuid: string): SaleKeysActionTypes {
    return {
        type: SALE_KEYS_CHANGE,
        uuid,
    };
}

export async function getDefaultSaleKeys(userId?: string): Promise<string | false> {
    if(userId) {
        const user = await determineDataSource()
            .then(source => source.users.get(userId) as any)
            .then(user => user.sale_keys)
            .catch(() => ""); // Ignore errors

        if(user !== "" && user !== "default") {
            return user;
        }
    }

    const register = getOption("register_default_sale_keys") as string;

    if(register !== "default") {
        return register;
    }

    const outlet = getOption("outlet_default_sale_keys") as string;

    if(outlet !== "default") {
        return outlet;
    }

    return getOption("default_sale_keys") ?? false;
}

export function resetSaleKeys(): ShopfrontThunk<SaleKeysActionTypes> {
    return async (dispatch, getState): Promise<void> => {
        const state = getState();

        const keys = await getDefaultSaleKeys(state.user.id === false ? undefined : state.user.id);

        if(keys) {
            dispatch(setSaleKeys(keys));
        }
    };
}
